/* MVS V11. Native links and scroll work without JavaScript; buttons are progressive enhancement. */
(() => {
  if (window.__mvsV11RailReady) return;
  window.__mvsV11RailReady = true;
  const instances = new Map();
  function setup(root = document) {
    root.querySelectorAll('[data-mvs-product-rail]').forEach(rail => {
      if (instances.has(rail)) return;
      const controls = rail.parentElement.querySelector('[data-mvs-rail-controls]');
      if (!controls) return;
      const prev = controls.querySelector('[data-mvs-rail-prev]');
      const next = controls.querySelector('[data-mvs-rail-next]');
      let frame = 0;
      const update = () => {
        frame = 0;
        const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        const offset = Math.abs(rail.scrollLeft);
        controls.hidden = max < 2;
        prev.disabled = offset < 2;
        next.disabled = offset >= max - 2;
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      const move = direction => {
        const rtl = getComputedStyle(rail).direction === 'rtl' ? -1 : 1;
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        rail.scrollBy({ left: rtl * direction * Math.max(200, rail.clientWidth - 32), behavior: reduced ? 'auto' : 'smooth' });
      };
      const backward = () => move(-1), forward = () => move(1);
      prev.addEventListener('click', backward);
      next.addEventListener('click', forward);
      rail.addEventListener('scroll', schedule, { passive: true });
      const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
      if (observer) observer.observe(rail);
      else window.addEventListener('resize', schedule, { passive: true });
      update();
      instances.set(rail, () => {
        prev.removeEventListener('click', backward);
        next.removeEventListener('click', forward);
        rail.removeEventListener('scroll', schedule);
        if (observer) observer.disconnect();
        else window.removeEventListener('resize', schedule);
        if (frame) cancelAnimationFrame(frame);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), { once: true });
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((dispose, rail) => {
      if (event.target.contains(rail)) { dispose(); instances.delete(rail); }
    });
  });
})();
